import { ELEMENT_TYPES } from '../unity/constants';
import { type CaptionTitleElement } from '../unity/elements/CaptionTitle';

const createCaptionTitleElement = (captionTitle?: string | null): CaptionTitleElement => ({
    type: ELEMENT_TYPES.CAPTION_TITLE,
    children: [{ text: captionTitle ?? '' }],
});

export default createCaptionTitleElement;
